import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../../../common/queryClient/getMutationFn';
import { UserBookmarkUrl } from './UserBookmarkUrl';

import {
  UserBookmarkFormDataType,
  UserBookmarkValidFormDataType,
} from '../schema/types';
import { UserBookmarkMutationDtoSchema } from '../schema/UserBookmarkSchema';

const postUserBookmark = (userBookmark: UserBookmarkValidFormDataType) =>
  apiClient
    .post<UserBookmarkFormDataType>(
      expand(UserBookmarkUrl.base, {}),
      UserBookmarkMutationDtoSchema.parse(userBookmark),
    )
    .then((response) => response.data);

const patchUserBookmark = (
  id: number,
  userBookmark: Partial<UserBookmarkValidFormDataType>,
) =>
  apiClient
    .put<UserBookmarkFormDataType>(
      expand(UserBookmarkUrl.base, { id }),
      UserBookmarkMutationDtoSchema.parse(userBookmark),
    )
    .then((response) => response.data);

const deleteUserBookmark = (id: number) =>
  apiClient
    .delete<void>(expand(UserBookmarkUrl.base, { id }))
    .then((response) => response.data);

export const useMutateUserBookmarkQuery = createApiMutationHook(
  ['user-bookmark'],
  getMutationFn(postUserBookmark, patchUserBookmark, deleteUserBookmark),
);
